import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
    Input,
    Form,
    Button,
    Modal,
    Divider,
    Switch,
    Tooltip,
    Spin,
} from 'antd'
import commonStyles from '../../../Utils/Common.less'
import { SaveOutlined, EditOutlined } from '@ant-design/icons'
import {
    defaultServiceProcessProperty,
    type ServiceProcessProperty,
    type ProcessCheckListItem,
} from '../../../Types/ToDoViewAllList'
import {
    GetServiceProcessAdditionalProperty,
    SetBusinessServiceProcessAdditionalProperty,
    SetProcessCheckList,
} from '../../../Services/ToDoViewAllList'
import { useDispatch } from 'react-redux'

interface checclistDataProps {
    CheckListData: ProcessCheckListItem[]
    serviceProcessId: number
    processListVisible: () => void
    serviceId: number
    setContineButtonDisable: React.Dispatch<React.SetStateAction<boolean>>
}
const CheckListPage = (props: checclistDataProps): React.ReactElement => {
    const {
        CheckListData,
        serviceProcessId,
        processListVisible,
        serviceId,
        setContineButtonDisable,
    } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [switchValues, setSwitchValues] = useState<Record<number, boolean>>(
        CheckListData.map((data) => data.serviceCheckListStatus === 1)
    )
    const [modalVisible, setModalVisible] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [activeIndex, setIndex] = useState<number | null>(null)
    const [active, setActive] = useState(false)
    const [buttonLoading, setButtonloading] = useState(false)
    const [showChecklist, setShowChecklist] = useState(false)
    const [isRequiredActive, setIsRequiredActive] = useState(false)
    const [ProcessAdditionalProperty, setProcessAdditionalProperty] =
        useState<ServiceProcessProperty>(defaultServiceProcessProperty)
    const [serviceProcessCheckListItem, setServiceProcessCheckListItem] =
        useState<string>('On hold')
    const [saveHoldButtonShow, setSaveHoldButtonShow] = useState(false)
    const [statusId, setStatusId] = useState(0)
    const [loading, setLoading] = useState<boolean>(false)
    const handleSwitchChange = (
        index: number,
        checked: boolean,
        isTargetItem: number
    ): void => {
        const newSwitchStates: Record<number, boolean> = {}
        CheckListData.forEach((_, idx) => {
            newSwitchStates[idx] = idx === index ? checked : false
        })
        setStatusId(isTargetItem)
        setIndex(index)
        const itemData = CheckListData[index]
        const isWithRemarks = serviceId !== 10 && (index === 0 || index === 1)
        if (
            checked &&
            itemData.itemName !== 'UK Team Approval' &&
            isWithRemarks
        ) {
            setModalTitle(itemData.itemName)
            setModalVisible(true)
            setActive(checked)
        } else if (serviceId !== 10) {
            void onSavePhone(itemData, checked, index, 0)
        }
        if (serviceId === 10) {
            setSwitchValues(newSwitchStates)

            if (isTargetItem === 39) {
                setContineButtonDisable(false)
                setServiceProcessCheckListItem(CheckListData[index].itemName)
            } else {
                setContineButtonDisable(checked)
            }

            // Only make API call for the specific item that was changed
            void SaveCallBackData(itemData, checked, index, 0)
        } else {
            setSwitchValues({ ...switchValues, [index]: checked })
        }
    }
    const handleSwitchChangeReqire = (checked: boolean): void => {
        setIsRequiredActive(checked)
        setShowChecklist(checked)
    }

    useEffect(() => {
        // Check if any serviceCheckListStatus in CheckListData.slice(2) is 1
        const hasActiveStatus = CheckListData?.slice(2)?.some(
            (data) => data?.serviceCheckListStatus === 1
        )
        setIsRequiredActive(hasActiveStatus)
        setShowChecklist(hasActiveStatus)
    }, [CheckListData])

    const onSaveData = (): void => {
        if (activeIndex !== null) {
            const itemData = CheckListData[activeIndex]
            void onSavePhone(itemData, active, activeIndex, 0)
        }
    }
    const onDataSaveOnhold = (): void => {
        void onDataSave(1)
    }
    const onDataSave = async (messegeShowId: number): Promise<void> => {
        try {
            const formdata = form.getFieldsValue()

            // Find the index of the item with serviceCheckListItemId === 39
            const targetItemIndex = CheckListData.findIndex(
                (item) => item.serviceCheckListItemId === 39
            )

            // Check if the switch for that item is checked
            const isTargetItemChecked =
                targetItemIndex !== -1 ? switchValues[targetItemIndex] : false

            const datasave = {
                serviceProcessId,
                serviceId,
                additionalPropertyName: serviceProcessCheckListItem,
                additinalPropertyValue: formdata.onholdData ?? '',
                advanceStatus: isTargetItemChecked ? 13 : 0,
            }
            await SetBusinessServiceProcessAdditionalProperty(
                dispatch,
                datasave,
                messegeShowId
            ).then((result) => {
                if (result !== null && result !== undefined) {
                    void onDataGetOnhold()
                }
            })
        } catch (error) {}
    }

    useEffect(() => {
        const itemDetails = CheckListData?.find(
            (item) => item.serviceCheckListItemId === 39
        )

        const datafetch = itemDetails?.serviceCheckListStatus === 1

        if (serviceId === 10 && datafetch) {
            void onDataGetOnhold()
            setSaveHoldButtonShow(itemDetails?.serviceCheckListStatus === 1)
        } else {
            if (serviceId === 10) {
                setContineButtonDisable(false)
            } else {
                setContineButtonDisable(true)
            }
        }
    }, [serviceProcessId, serviceId, CheckListData])

    useEffect(() => {
        if (serviceId === 10 && activeIndex !== null) {
            const isSwitchOn = switchValues[activeIndex]
            if ((isSwitchOn || !isSwitchOn) && statusId === 39) {
                setLoading(true)
                void onDataSave(0)
                setStatusId(0)
            }
        }
    }, [activeIndex, switchValues, statusId])

    const onDataGetOnhold = async (): Promise<void> => {
        try {
            const data = await GetServiceProcessAdditionalProperty(
                dispatch,
                serviceProcessId,
                serviceId,
                serviceProcessCheckListItem
            )
            if (data !== null && data !== undefined) {
                setLoading(false)
                setProcessAdditionalProperty(data)
                form.setFieldsValue({
                    onholdData: data?.additinalPropertyValue ?? '',
                })
                if (data?.additinalPropertyValue?.length > 0) {
                    setSaveHoldButtonShow(true)
                } else {
                    setSaveHoldButtonShow(false)
                }
            } else {
                setSaveHoldButtonShow(false)
            }
        } catch (error) {}
    }
    const SaveCallBackData = async (
        datas: ProcessCheckListItem,
        checked: boolean,
        index: number,
        messegeShowId: number
    ): Promise<void> => {
        const dataToSave = {
            processCheckListItemId: datas.processCheckListItemId,
            serviceCheckListItemId: datas.serviceCheckListItemId,
            serviceProcessId,
            serviceCheckListStatus: checked ? 1 : 0,
            itemType: datas.itemType ?? 0,
            remarks: '',
            itemName: '',
            itemDescription: '',
            processStatusId: 0,
        }
        await SetProcessCheckList(dispatch, dataToSave, messegeShowId)
            .then((result) => {
                if (result !== null && result !== undefined) {
                    setButtonloading(false)
                }
            })
            .catch(() => {})
    }
    const onSavePhone = async (
        datas: ProcessCheckListItem,
        checked: boolean,
        index: number,
        messegeShowId: number
    ): Promise<void> => {
        try {
            const isWithRemarks =
                serviceId === 10
                    ? index === 0 || index === 1 || index === 2
                    : index === 0 || index === 1
            if (isWithRemarks) {
                try {
                    await form.validateFields()
                    setButtonloading(true)
                    const formData = form.getFieldsValue()

                    const dataToSave = {
                        processCheckListItemId: datas.processCheckListItemId,
                        serviceCheckListItemId: datas.serviceCheckListItemId,
                        serviceProcessId,
                        serviceCheckListStatus: checked ? 1 : 0,
                        itemType:
                            datas.itemName === 'Dormant' ||
                            datas.itemName === 'Nil Return'
                                ? 1
                                : (datas.itemType ?? 0),
                        remarks: formData.description ?? ' ',
                        itemName: '',
                        itemDescription: '',
                        processStatusId: 0,
                    }
                    await SetProcessCheckList(
                        dispatch,
                        dataToSave,
                        messegeShowId
                    )
                        .then((result) => {
                            if (result !== null && result !== undefined) {
                                setButtonloading(false)
                            }
                        })
                        .catch(() => {})
                    if (serviceId !== 10) {
                        processListVisible()
                    }

                    setModalVisible(false)
                    form.setFieldsValue({
                        description: '',
                    })
                } catch (error) {}
            } else {
                await form.validateFields()
                setButtonloading(true)

                void SaveCallBackData(datas, checked, index, messegeShowId)
            }
        } catch (error) {}
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    useEffect(() => {
        if (!saveHoldButtonShow) {
            form.setFieldsValue({
                onholdData: ProcessAdditionalProperty?.additinalPropertyValue,
            })
        } else {
            form.setFieldsValue({
                onholdData: '',
            })
        }
    }, [saveHoldButtonShow])
    return (
        <>
            <div className={commonStyles.formWrapper}>
                <Form
                    name="complex-form"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    layout={'vertical'}
                    autoComplete="off"
                    form={form}
                    size="small"
                >
                    {serviceId === 10 ? (
                        <Spin spinning={Boolean(loading)} size="large">
                            <>
                                {CheckListData?.filter(
                                    (data) => data.itemName !== 'Review flow'
                                )?.map((data, index) => {
                                    const isTargetItem =
                                        data.serviceCheckListItemId === 39

                                    const isSwitchOn =
                                        switchValues[index] ??
                                        data?.serviceCheckListStatus === 1

                                    return (
                                        <Row
                                            gutter={16}
                                            style={{ marginTop: '15px' }}
                                            key={index}
                                        >
                                            <Col span={4}>
                                                <div>
                                                    <Switch
                                                        defaultChecked={
                                                            data?.serviceCheckListStatus ===
                                                            1
                                                        }
                                                        checked={
                                                            switchValues[index]
                                                        } // Adjusted for sliced data
                                                        onChange={(checked) => {
                                                            handleSwitchChange(
                                                                index,
                                                                checked,
                                                                data.serviceCheckListItemId
                                                            )
                                                        }}
                                                    />{' '}
                                                    <span
                                                        style={{
                                                            marginLeft: '10px',
                                                            fontWeight:
                                                                switchValues[
                                                                    index
                                                                ]
                                                                    ? 'bold'
                                                                    : 'normal',
                                                        }}
                                                    >
                                                        {data?.itemName}
                                                    </span>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    {/* Your ConverCodeToReact component can be added here */}
                                                    {/* <ConverCodeToReact html={data?.itemDescription} /> */}
                                                </div>
                                            </Col>{' '}
                                            {isTargetItem && isSwitchOn && (
                                                <Col span={8}>
                                                    <Row
                                                        gutter={8}
                                                        align="middle"
                                                    >
                                                        <Col flex="auto">
                                                            {saveHoldButtonShow ? (
                                                                ProcessAdditionalProperty?.additinalPropertyValue
                                                            ) : (
                                                                <Form.Item name="onholdData">
                                                                    <Input.TextArea
                                                                        rows={2}
                                                                        allowClear
                                                                        placeholder="Add your comment"
                                                                    />
                                                                </Form.Item>
                                                            )}
                                                        </Col>
                                                        <Col>
                                                            {saveHoldButtonShow ? (
                                                                <Tooltip title="Edit On hold Details">
                                                                    <Button
                                                                        type="primary"
                                                                        onClick={() => {
                                                                            setSaveHoldButtonShow(
                                                                                false
                                                                            )
                                                                        }}
                                                                        size="small"
                                                                        icon={
                                                                            <EditOutlined />
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip title="Save On hold Details">
                                                                    <Button
                                                                        type="primary"
                                                                        onClick={
                                                                            onDataSaveOnhold
                                                                        }
                                                                        size="small"
                                                                        icon={
                                                                            <SaveOutlined />
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )}
                                        </Row>
                                    )
                                })}
                            </>
                        </Spin>
                    ) : (
                        <>
                            {CheckListData?.length !== 1 && serviceId === 9 && (
                                <>
                                    <Row
                                        gutter={16}
                                        style={{ marginTop: '15px' }}
                                    >
                                        {/* Main controlling switch */}

                                        <Col span={1}>
                                            <Switch
                                                checked={isRequiredActive}
                                                onChange={
                                                    handleSwitchChangeReqire
                                                }
                                            />
                                        </Col>
                                        <Col span={16}>
                                            {' '}
                                            <span>Required</span>
                                        </Col>
                                    </Row>
                                    {showChecklist && (
                                        <>
                                            <Row
                                                gutter={16}
                                                style={{ marginTop: '15px' }}
                                            >
                                                {CheckListData?.slice(2)?.map(
                                                    (data, index) => (
                                                        <Col
                                                            span={4}
                                                            key={index + 2}
                                                        >
                                                            <div>
                                                                <Switch
                                                                    defaultChecked={
                                                                        data?.serviceCheckListStatus ===
                                                                        1
                                                                    }
                                                                    checked={
                                                                        switchValues[
                                                                            index +
                                                                                2
                                                                        ]
                                                                    } // Adjusted for sliced data
                                                                    onChange={(
                                                                        checked
                                                                    ) => {
                                                                        handleSwitchChange(
                                                                            index +
                                                                                2,
                                                                            checked,
                                                                            data.serviceCheckListItemId
                                                                        )
                                                                    }}
                                                                    disabled={
                                                                        data?.serviceCheckListStatus ===
                                                                        1
                                                                    }
                                                                />{' '}
                                                                <span
                                                                    style={{
                                                                        marginLeft:
                                                                            '10px',
                                                                        fontWeight:
                                                                            switchValues[
                                                                                index +
                                                                                    2
                                                                            ]
                                                                                ? 'bold'
                                                                                : 'normal',
                                                                    }}
                                                                >
                                                                    {
                                                                        data?.itemName
                                                                    }
                                                                </span>
                                                            </div>

                                                            <div
                                                                style={{
                                                                    marginTop:
                                                                        '10px',
                                                                }}
                                                            >
                                                                {/* Your ConverCodeToReact component can be added here */}
                                                                {/* <ConverCodeToReact html={data?.itemDescription} /> */}
                                                            </div>
                                                        </Col>
                                                    )
                                                )}
                                            </Row>
                                            <div
                                                style={{
                                                    fontSize: '11px',
                                                }}
                                            >
                                                This option will be
                                                automatically enabled when
                                                services are active to this
                                                client. If you want to remove
                                                this option you should disable
                                                the service in client
                                                registration window.
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {CheckListData?.map((data, index) => (
                                <>
                                    {/* For index 0 and 1, render in separate rows */}
                                    {index === 0 || index === 1 ? (
                                        <>
                                            <div style={{ marginTop: '15px' }}>
                                                <Row gutter={16} key={index}>
                                                    <Col span={1}>
                                                        <Switch
                                                            defaultChecked={
                                                                data.serviceCheckListStatus ===
                                                                1
                                                            }
                                                            checked={
                                                                switchValues[
                                                                    index
                                                                ]
                                                            }
                                                            onChange={(
                                                                checked
                                                            ) => {
                                                                handleSwitchChange(
                                                                    index,
                                                                    checked,
                                                                    data.serviceCheckListItemId
                                                                )
                                                            }}
                                                            disabled={
                                                                data.serviceCheckListStatus ===
                                                                1
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={16}>
                                                        <span
                                                            style={{
                                                                fontWeight:
                                                                    switchValues[
                                                                        index
                                                                    ] ||
                                                                    data.serviceCheckListStatus ===
                                                                        1
                                                                        ? 'bold'
                                                                        : 'normal',
                                                            }}
                                                        >
                                                            {data?.itemName}
                                                        </span>{' '}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <div
                                                        style={{
                                                            whiteSpace:
                                                                'pre-line',
                                                            fontSize: '11px',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        {convertHtmlToFormattedText(
                                                            data.itemDescription
                                                        )}
                                                    </div>
                                                </Row>
                                            </div>

                                            <Divider dashed />
                                        </>
                                    ) : null}
                                </>
                            ))}
                        </>
                    )}

                    {/* <div>
                        This option will be automatically enabled when services
                        are active to this client. If you want to remove this
                        option you should disable the service in client
                        registration window.
                    </div> */}
                </Form>
            </div>
            <Modal
                footer={null}
                onCancel={() => {
                    setModalVisible(false)
                }}
                width={'45%'}
                title={modalTitle}
                open={modalVisible}
            >
                <div className={commonStyles.formWrapper}>
                    <Form
                        name="complex-form"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValues={{ remember: true }}
                        layout={'vertical'}
                        autoComplete="off"
                        form={form}
                        size="small"
                        requiredMark={customizeRequiredMark}
                    >
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    label="Description "
                                    name="description"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please select your description!',
                                        },
                                    ]}
                                >
                                    <Input.TextArea rows={4} />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col offset={21} span={2}>
                                <Button
                                    type="primary"
                                    size="middle"
                                    onClick={onSaveData}
                                    loading={buttonLoading}
                                >
                                    <SaveOutlined />
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
export default CheckListPage

function convertHtmlToFormattedText(html: string): string {
    return `${html
        .replace(/<br\s*\/?>/gi, '\n') // convert <br> to newline
        .replace(/<\/?[^>]+(>|$)/g, '') // remove any other HTML tags
        .trim()}` // wrap in parentheses
}
